import React from 'react';
import { Grid, SmallBodyText, SmallBodyTextNoWrap } from '../../../ui-toolkit';
import styled from 'styled-components';

const SmallBodyTextOverflowEllipsis = styled(SmallBodyTextNoWrap)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderLabelTextPair: React.FC<{ label: string; text: string; overflow?: string }> = ({
  label,
  text,
  overflow = 'inherit',
}) => (
  <Grid templateColumns={'min-content 1fr'} columnGap={'spacing2'}>
    <SmallBodyText intent={'faded'}>{`${label}:`}</SmallBodyText>
    {overflow === 'ellipsis' && <SmallBodyTextOverflowEllipsis>{text}</SmallBodyTextOverflowEllipsis>}
    {overflow !== 'ellipsis' && <SmallBodyTextNoWrap>{text}</SmallBodyTextNoWrap>}
  </Grid>
);
